import { CardVariantsEnum } from "../../utils/dataTransform/ContentQueryWidget/types.ts";

const CARD_GRID = "card-grid";
const PLAYLIST = "playlist";
const CAROUSEL = "carousel";
const MIXED_CARD_LAYOUT = "mixed_card_layout";

const DEFAULT_SWIMLANE_LAYOUT = {
    name: CARD_GRID,
    columns: 5,
    rows: 1,
    variant: CardVariantsEnum.STANDARD,
};

const TRENDING_SWIMLANE_LAYOUT = {
    name: CARD_GRID,
    columns: 5,
    variant: CardVariantsEnum.DISCOVERY,
};

export {
    CARD_GRID,
    DEFAULT_SWIMLANE_LAYOUT,
    PLAYLIST,
    TRENDING_SWIMLANE_LAYOUT,
    CAROUSEL,
    MIXED_CARD_LAYOUT,
};
